import * as types from './month.constant';

export const changMonthSelect = (data) => ({
    type: types.CHANGE_MONTH_SELECT,
    payload: {
        data,
    },
});
